import {IomoSpiralLayout} from './iomoSpiralLayout';
import {IomoLinearLayout} from './iomoLinearLayout';
import {IomoClusterLayout} from './iomoClusterLayout';
import {IomoLayout} from './iomoLayout';

const iomoLayouts = {
	spiral: new IomoSpiralLayout(),
	linear: new IomoLinearLayout(),
	cluster: new IomoClusterLayout(),
	none: new IomoLayout()
};

export {iomoLayouts};

